import {
    Box3,
    Mesh,
    MeshBasicMaterial,
    PlaneGeometry, Quaternion,
    Sphere,
    TextureLoader,
    Vector3,
} from 'three';
import { settingsData, threeJsVariables } from '../../../settings';
import { autoRotateTimerAction, rotateToCamera } from '../../controls/orbitControls';

const selectionBoxesBox = {};

const axisZ = new Vector3( 0, 0, 1 ).normalize();
const axisY = new Vector3(0,1,0).normalize();
const quaternion = new Quaternion();

export function rotateHoverCursorWithCamera () {
    if (!config.features.cursor?.active){
        return;
    }

    const hover = threeJsVariables.scene.getObjectByName('Building hover');
    if (!hover){
        return;
    }

    if (hover.visible){
        const hoverPosition = hover.getWorldPosition(new Vector3());
        const vec = new Vector3();

        quaternion.setFromAxisAngle(axisY, threeJsVariables.orbitControls.getAzimuthalAngle());
        vec.applyQuaternion(quaternion);

        const cursorVec = new Vector3().copy(hoverPosition);
        cursorVec.add(vec);

        hover.position.set(cursorVec.x, hoverPosition.y, cursorVec.z);
        hover.rotation.set(0, rotateToCamera(-Math.PI / 2), 0);
    }

}

export function updateHoverPosition (building, y, action) {
    if (!config.features.cursor?.active){
        return;
    }

    const radiusDivide = config.features.cursor.radiusDivide;

    const hover = threeJsVariables.scene.getObjectByName('Building hover');
    if (!hover){
        return;
    }

    switch (action) {
        case 'show':
            const selectionBoxValues = getSelectionBoxValues(building.name);
            if (!selectionBoxValues){
                return;
            }

            autoRotateTimerAction('update');

            const {center, sphere} = selectionBoxValues;

            const axisVec = new Vector3().copy(axisZ);
            const cursorVec = new Vector3().copy(center);
            const scalarVec = new Vector3();

            // scalarVec.add( axisVec.multiplyScalar(sphere.radius / radiusDivide) );
            quaternion.setFromAxisAngle(axisY, threeJsVariables.orbitControls.getAzimuthalAngle());
            scalarVec.applyQuaternion(quaternion);

            cursorVec.add(scalarVec);
            // cursorVec.applyQuaternion(quaternion);

            hover.position.set(cursorVec.x, y, cursorVec.z);
            hover.rotation.set(0, rotateToCamera(-Math.PI / 2), 0);
            hover.visible = true;

            settingsData.animateBuildingHover = true;

            break;
        case 'hide':
            hover.visible = false;
            settingsData.animateBuildingHover = false;

            break;
    }
}

export function calculateBoxForSelectionBoxes (selectionBoxes) {
    if (!config.features.cursor?.active){
        return;
    }

    selectionBoxes.forEach(sBox =>{
        const center = sBox.getWorldPosition(new Vector3());
        const sphere = new Box3().setFromObject(sBox).getBoundingSphere(new Sphere());

        selectionBoxesBox[sBox.name] = {
            center,
            sphere
        };
    });
}

function getSelectionBoxValues (buildingName) {
    return selectionBoxesBox[`${buildingName}_selectionBoxes`];
}
